import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';

export const useHasForgeAccess = (): boolean => {
	const isAnonymous = useIsAnonymous();
	return !isAnonymous;
};
